import { 프랜차이즈_Desktop } from "../../components/프랜차이즈_Desktop";
import * as 장치 from "../../components/장치";

import type { GetServerSideProps } from "next";
import { 프랜차이즈_Mobile } from "../../components/프랜차이즈_Mobile";
import { loadApplicationPageProps, type ApplicationPageProps } from "../_app";
import { LayoutSplitter } from "../../layouts/LayoutSplitter";

type 프랜차이즈Props = {
  장치: 장치.t;
};

const 프랜차이즈 = ({ 장치 }: 프랜차이즈Props) => {
  return (
    <LayoutSplitter
      장치={장치}
      pc={<프랜차이즈_Desktop />}
      mobile={<프랜차이즈_Mobile />}
    />
  );
};

export default 프랜차이즈;

export const getServerSideProps: GetServerSideProps<
  프랜차이즈Props & ApplicationPageProps
> = async (ctx) => {
  const applicationPageProps = await loadApplicationPageProps(ctx);
  return {
    props: {
      장치: 장치.fromContext(ctx),
      ...applicationPageProps,
    },
  };
};
